import React, { useRef } from 'react';
import logoSrc from '../img/logo.png'; // Assuming logo.png is in the img folder
import ContactForm from '../ContactForm'; // Make sure this component has the `openForm` method.


function PhotographyVideo() {
  const contactFormRef = useRef(); // Reference for controlling the contact form

  // Function to open the contact form
  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm(); // Ensure the `ContactForm` has this method.
    }
  };

  return (
    <>
     
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          {/* Left Side Content */}
          <div className="banner-text">
            <h1 className="banner-title" >move or not, we are capturing</h1>
            <p className="banner-description">
              Capture your vision with our professional photography and video services, tailored to create engaging and high-quality visual content.
            </p>
            <a
              onClick={handleOpenContactForm} // Open the form on button click
              className="banner-button"
            >
              Start Now
            </a>

          </div>
          {/* Background Image */}
        </div>
      </section>
      <div className='img-background'>
      <img
              className="img"
              id='banner1-video'
              src="/img/Main Services Thumbnail.png"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
              alt="img"
            />
      </div>

      {/* Custom Photography Section */}
      <section className="about-section">
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Custom Photography</strong></h2>
            <p>We offer bespoke photography services to showcase your product, event, or brand in the best light.</p>
            <ul>
              <p><strong>Event Photography:</strong> Capturing special moments in stunning detail.</p>
              <p><strong>Product Photography:</strong> Professional shots to highlight your product.</p>
              <p><strong>Corporate Photography:</strong> Reflecting your company’s image through compelling visuals.</p>
              <p><strong>Portrait Photography:</strong> Personalized sessions to capture your essence.</p>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/m5.1.png" alt="Custom Photography" />
          </div>
        </div>

        {/* Video Production Section */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Video Production</strong></h2>
            <p>Our video production services offer end-to-end solutions, from concept development to post-production, delivering engaging videos that tell your story.</p>
            <ul>
              <p><strong>Commercial Videos:</strong> High-impact videos for marketing and advertisements.</p>
              <p><strong>Corporate Videos:</strong> Communicate your brand’s message effectively.</p>
              <p><strong>Event Videos:</strong> Capture live moments with cinematic quality.</p>
              <p><strong>Documentary Videos:</strong> Storytelling through compelling visual narratives.</p>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/m5.2.png" alt="Video Production" />
          </div>
        </div>

        {/* Photography & Video Portfolio Section */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Our Portfolio</strong></h2>
            <p>Explore our portfolio to see how we’ve brought our clients’ visions to life through photography and video.</p>
            <a href="/blog" className="cta-button">Browse Portfolio</a>
          </div>
          <div className="about-image">
            <img src="/img/m5.3.png" alt="Photography & Video Portfolio" />
          </div>
        </div>
      </section>
      
  <ContactForm ref={contactFormRef} />
    </>
  );
}

export default PhotographyVideo;
